import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectors, stateKeys, actions } from '../../../../model';
import StepContainer from '../../../ui/StepContainer/StepContainer';
import DownloadErrorsFile from '../../../controllers/DownloadErrorsFile/DownloadErrorsFile';
import Btn, { btnTypes } from '../../../../../../../../components/btn';
import styles from './Result.module.scss';

const { selectStateValue } = selectors;
const { resetStateAction } = actions;

const resultSelector = (state) => selectStateValue(state, stateKeys.resultData);

const Result = () => {
  const { title, errorsWorkbook, errorsFile } = useSelector(resultSelector);

  const dispatch = useDispatch();

  return (
    <>
      <StepContainer.Title>{title}</StepContainer.Title>
      <StepContainer.BoundingWrap grow>
        <DownloadErrorsFile
          workbook={errorsWorkbook}
          file={errorsFile}
        >
          При загрузке в некоторых записях обнаружены ошибки
        </DownloadErrorsFile>

        <StepContainer.Footer>
          <Btn
            type={btnTypes.primaryInvert}
            onClick={() => dispatch(resetStateAction())}
            className={styles.resetBtn}
          >
            Импортировать новые данные
          </Btn>
        </StepContainer.Footer>
      </StepContainer.BoundingWrap>
    </>
  );
};

export default Result;
